import { Component, Renderer2, OnInit, HostListener } from '@angular/core';
import { DatasearchService } from '../../_services/datasearch.service';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-ethics',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, NgFor, NgIf, NgClass],
  templateUrl: './ethics.component.html',
  styleUrls: ['./ethics.component.scss'],
})
export class EthicsComponent implements OnInit {
  data: any;
  highlightedIndex: number | null = null;
  currentPage: string = 'ethics';
  head: any[] = [];

  constructor(
    private datasearchService: DatasearchService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.getData();
    this.getHeading();
  }

  ngAfterViewInit() {
    this.observeScrolling(); // Start observing after the view is initialized
  }

  getData() {
    this.datasearchService.getEthics().subscribe((res) => {
      this.data = res.data;
    });
  }

  observeScrolling() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute('id');
          if (id) {
            const index = parseInt(id.split('-')[1], 10); // Extract index from the ID
            const titleElement = document.getElementById('title-' + index);

            if (entry.isIntersecting && titleElement) {
              this.highlightedIndex = index; // Set the highlighted index
              this.renderer.addClass(titleElement, 'highlight'); // Add highlight class
            } else if (titleElement) {
              this.renderer.removeClass(titleElement, 'highlight'); // Remove highlight class
            }
          }
        });
      },
      {
        threshold: 0.6, // Adjust to control how much of the element should be visible
        rootMargin: '-40% 0px -40% 0px', // Adjust to ensure the element is centered vertically
      }
    );

    // Start observing only after the view is rendered
    setTimeout(() => {
      this.data?.forEach((_: any, i: number) => {
        const descriptionElement = document.getElementById('description-' + i);
        if (descriptionElement) {
          observer.observe(descriptionElement); // Observe each description
        }
      });
    }, 0);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    this.data.forEach((_: any, i: number) => {
      const descriptionElement = document.getElementById('description-' + i);
      if (descriptionElement) {
        const rect = descriptionElement.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          this.highlightedIndex = i; // Manually set highlighted index
        }
      }
    });
  }

  getHeading() {
    this.datasearchService.getAllHeadings().subscribe((res) => {
      if (res.success) {
        this.head = res.data.filter(
          (heading: any) => heading.page === this.currentPage
        );
      }
    });
  }

  toggledescription(index: number) {
    const descriptionElement = document.getElementById('description-' + index);

    if (descriptionElement) {
      // Scroll to the description element smoothly
      descriptionElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      // Optional: Add a slight delay for additional logic
      // Adjust the timeout duration as needed
    }
  }
}
